var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditTableActionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "EditTableSvg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29.4085,
    height: 29,
    rx: 5,
    fill: "var(--primary)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.59 12.0133L16.2119 12.6267L10.0869 18.6667H9.46491V18.0533L15.59 12.0133ZM18.0238 8C17.8548 8 17.679 8.06667 17.5505 8.19333L16.3134 9.41333L18.8486 11.9133L20.0857 10.6933C20.3494 10.4333 20.3494 10.0133 20.0857 9.75333L18.5038 8.19333C18.3686 8.06 18.1996 8 18.0238 8ZM15.59 10.1267L8.11279 17.5V20H10.648L18.1252 12.6267L15.59 10.1267Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTableActionIcon);
export default __webpack_public_path__ + "static/media/edit-table-action-icon.3cbf86f18377a09d68abcabe3decb57f.svg";
export { ForwardRef as ReactComponent };